module.exports = __webpack_public_path__ + "img/downTime.14747d25.png";